import React from 'react'
import Paper from '@mui/material/Paper';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css/autoplay';
import 'swiper/css';


const Affiliations = () => {
    return (
        <>
            <div className='my-2'>
                <Paper elevation={3}>
                    <div className='p-5'>

                        <div className="text-center">
                            <h2>
                                {/* Affiliations & Approvals */}
                                AFFILIATIONS & APPROVALS
                            </h2>
                        </div>
                        <div className='text-center pb-4'>
                            <i> <small> Purbanchal Educational Welfare Society (PEWS) Group of Institutions, affiliated with the Indian Association of Physiotherapists (IAP), Indian Nursing Council (INC), State Nursing Council (Assam), and accredited by the Government of India, offers comprehensive healthcare education of the highest quality.</small></i>
                        </div>
                        <div className="row p-2">
                            <div className="col-12">
                                <div className="row p-2 ">
                                    <div className="col-12">
                                        <div>
                                            <Swiper
                                                // slidesPerView={3}
                                                // pagination={{ clickable: true }}
                                                spaceBetween={10}
                                                // loop={true}
                                                autoplay={true}
                                                centeredSlides={false}
                                                centerInsufficientSlides={true}
                                                navigation={{
                                                    clickable: true,
                                                    nextEl: '.review-swiper-button-next',
                                                    prevEl: '.review-swiper-button-prev',
                                                }}
                                                modules={[Autoplay, Pagination, Navigation, Scrollbar]}
                                                className="testimonials-slider swiper"
                                                data-aos="fade-up"
                                                data-aos-delay="100"
                                                breakpoints={{
                                                    // when window width is >= 640px
                                                    340: {
                                                        //   width: 640,
                                                        slidesPerView: 3,
                                                    },
                                                    // when window width is >= 768px
                                                    768: {
                                                        //   width: 768,
                                                        slidesPerView: 3,
                                                    },
                                                    968: {
                                                        //   width: 768,
                                                        slidesPerView: 7,
                                                    },

                                                }}
                                            >




                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/1.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                {/* <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/2.jpg" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide> */}
                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/3.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/4.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/5.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/6.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide>
                                                    <div className="p-1">
                                                        <div>
                                                            <img src="assets/affiliation/7.png" alt="affi" className='col-12' />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>


                    </div>
                </Paper >
            </div >
        </>
    )
}

export default Affiliations;